import React from 'react'
import QueryEditor from 'coact/QueryEditor'
import { array, object, func } from 'prop-types'

class IncomeStatement extends React.Component {
  constructor (props) {
    super(props)
    this.downloadExcel = this.downloadExcel.bind(this)
  }
  downloadExcel () {
    console.log('press download button')
    function buildUrl (url, query) {
      if (!query) return url

      const querys = []
      Object.keys(query).forEach(key => {
        if (query[key] === undefined) return
        querys.push(`${key}=${encodeURIComponent(JSON.stringify(query[key]))}`)
      })
      return `${url}?${querys.join('&')}`
    }

    const { queries } = this.props
    const url = buildUrl(`api/print/${this.select.value}/xlsx`, queries)
    window.open(url, '_blank')
  }
  render () {
    const { queries, setQueries, fields, schema } = this.props

    return (
      <div>
        <QueryEditor {...{
          value: queries,
          onChange: setQueries,
          fields, schema,
        }}
        />
        <select
          ref={ref => (this.select = ref)}
          onChange={this.handleSelect}
        >
          <option value=""> ---- choose ---- </option>
          <option value="incomeStatement">損益表 Template(舊版)</option>
          <option value="incomeStatementNew">損益表 Template(2018年版)</option>
          <option value="incomeStatement2023">損益表 Template(2023年版)</option>
        </select>
        <br />
        <input
          type="button"
          id="download_excel"
          value="下載"
          onClick={this.downloadExcel}
        />
      </div>
    )
  }
}

IncomeStatement.propTypes = {
  fields: array.isRequired,
  queries: object.isRequired,
  setQueries: func.isRequired,
  schema: object.isRequired,
}

export default IncomeStatement



// WEBPACK FOOTER //
// ./src/components/IncomeStatement/IncomeStatement.jsx